import axios, { AxiosResponse, CancelToken } from "axios"
import { VerificarPagaresCommandProps } from "./Commands/VerificarPagaresCommand"
import { GetPagaresAceptablesDtoProps } from "./DTOs/GetPagaresAceptablesDto"
import { pagaresAceptableAdapter } from "./Pagare.adapter"
import { GetPagaresAceptablesDtoIPagedEnumerableProps } from "./Schemas/GetPagaresAceptablesDtoIPagedEnumerable"
import { EstadoVerificacionEfectoType } from "./Types/EstadoVerificacionEfecto"

type SortingCriteria = {
  sort?: "ASC" | "DESC"
  property?: string
}

interface AceptablesQueryParamsProps {
  EmpresaId?: string
  Estados?: EstadoVerificacionEfectoType[]
  FechaEmisionLowerLimit?: string
  FechaEmisionUpperLimit?: string
  ImporteLowerLimit?: number | string
  ImporteUpperLimit?: number | string
  Keyword?: string
  MaxResultCount?: number | string
  SkipCount?: number | string
  SortingCriteria: SortingCriteria
}

export async function getPagaresAceptables(
  queryParams: AceptablesQueryParamsProps,
  cancelToken?: CancelToken
): Promise<GetPagaresAceptablesDtoIPagedEnumerableProps> {
  const { data }: { data: GetPagaresAceptablesDtoIPagedEnumerableProps } =
    await axios.get("/Pagare/aceptables/", {
      params: queryParams,
      cancelToken,
    })
  return {
    currentPage: data.currentPage,
    items: data?.items?.map((pagare: GetPagaresAceptablesDtoProps) =>
      pagaresAceptableAdapter(pagare)
    ),
    totalCount: data.totalCount,
  }
}

/**
 * @description Check if User has any Pagaré
 * @returns {Boolean}
 */
export async function hasAnyPagare(
  queryParams?: EstadoVerificacionEfectoType[]
): Promise<boolean> {
  const { data }: Record<"data", boolean> = await axios.get("/Pagare/any", {
    params: queryParams,
  })
  return data
}

export async function isFirstPagare(): Promise<boolean> {
  const { data }: Record<"data", boolean> = await axios.get(
    "/Pagare/any-estado-verificacion-actualizado"
  )
  return data
}

export async function getPagarePdfById(id: string) {
  const { data, status } = await axios.get(`/Pagare/${id}/fichero`, {
    responseType: "blob",
  })
  return { data, status }
}

export async function putVerificarPagare(
  body: VerificarPagaresCommandProps
): Promise<AxiosResponse> {
  const response = await axios.put("/Pagare/verificar", body)
  return response
}
